export default {"src":"/_next/static/media/link-icon.1755f706.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};